var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isBlockedDesktop)?_c('div',{staticClass:"not-found-page"},[_vm._m(0)]):_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-content"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Page Not Found")]),_c('p',{staticClass:"sub-text"},[_vm._v("The page you are looking for does not exist.")])])
}]

export { render, staticRenderFns }